import {useState} from 'react'
import Button from 'components/ui/Button'
import Locations from '../locations/Locations'
import TextField from 'components/ui/TextField'
import {Link, useNavigate} from 'react-router-dom'
import {enqueueSnackbar} from 'notistack'
import {IAdditionalInformationField, useCreateClassMutation} from 'services/classes'
import * as Styles from 'layouts/PrivateLayout.styles'

const CreateTruckModule = () => {
    const [createClass] = useCreateClassMutation()
    const navigate = useNavigate()
    const [className, setClassName] = useState('')
    const [linkedProduct, setLinkedProduct] = useState('')
    const [additionalInformation, setAdditionalInformation] = useState<
        readonly IAdditionalInformationField[]
    >([])
    const [locations, setLocations] = useState<readonly number[]>([])
    const disableSubmit = !className.length

    const [selectedVariant, setSelectedVariant] = useState<any>(null)
    const [truckType, setTruckType] = useState<number | ''>(''); // Default empty state

    const handleLinkedProductChange = (selectedVariant: any) => {
        setSelectedVariant(selectedVariant)
    }

    const [truckCapacity, setTruckCapacity] = useState({
        store_id: '',
        truck_id: ''
    })

    const locationsColumns = [{field: 'name', headerName: 'Location'}]

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        let additionalFields = {}

        if (additionalInformation.length > 0) {
            const mappedAdditionalInfo = additionalInformation.map((field: any) => {
                return {
                    title: field.title,
                    status: field.status
                }
            })
            // Check for empty titles in additional information
            const emptyTitles = mappedAdditionalInfo.filter(
                (field: any) => !field.title.trim()
            )
            if (emptyTitles.length > 0) {
                enqueueSnackbar(
                    'Additional information fields cannot have empty titles',
                    {variant: 'error', autoHideDuration: 1000}
                )
                return
            }

            additionalFields = {
                fields: mappedAdditionalInfo
            }
        }

        if (truckType === '') {
            enqueueSnackbar('Please select a truck type', {
                variant: 'error',
                autoHideDuration: 1000,
            });
            return;
        }
        const data = {
            body: {
                name: className,
                time_zone: 'America/Los Angeles',
                truck_type: truckType, // Include the selected truck type
                additional_information_fields: additionalFields,
                location_active_ids: locations,
            },
        };
        try {
            const results: any = await createClass(data)
            console.log(results)
            if (results.class) {
                enqueueSnackbar('Truck successfully created', {
                    variant: 'success',
                    autoHideDuration: 1000
                })

                navigate('/admin/classes')
            } else {
                enqueueSnackbar('There was an error saving truck, please try again later', {
                    variant: 'error',
                    autoHideDuration: 1000
                })
            }


        } catch (error) {
            enqueueSnackbar('Failed to create class. Please try again.', {
                variant: 'error',
                autoHideDuration: 1000
            })
        }
    }

    return (
        <div>
            <Styles.CreateEditPageTitleContainer>
                Create a new Truck
            </Styles.CreateEditPageTitleContainer>
            <form onSubmit={handleSubmit}>
                <Styles.FormColumns>
                    <Styles.FormColumnLeft>
                        <Styles.FormColumnLeftDescription>
                            <strong>Truck Name*</strong>
                        </Styles.FormColumnLeftDescription>
                    </Styles.FormColumnLeft>
                    <Styles.FormColumnRight>
                        <TextField
                            id="className"
                            required
                            cc-width="full"
                            label="Truck name"
                            onChange={(e) => setClassName(e.target.value)}
                        ></TextField>
                    </Styles.FormColumnRight>
                </Styles.FormColumns>
                <Styles.FormColumns>
                    <Styles.FormColumnLeft>
                        <Styles.FormColumnLeftDescription>
                            <strong>Truck Type*</strong>
                        </Styles.FormColumnLeftDescription>
                    </Styles.FormColumnLeft>
                    <Styles.FormColumnRight>
                        <select
                            id="truckType"
                            required
                            value={truckType}
                            onChange={(e) => setTruckType(Number(e.target.value))}
                            style={{
                                width: '100%',
                                padding: '8px',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                            }}
                        >
                            <option value="" disabled>
                                Select Truck Type
                            </option>
                            <option value={0}>Dump Truck</option>
                            <option value={1}>Box Truck</option>
                        </select>
                    </Styles.FormColumnRight>
                </Styles.FormColumns>

                <Locations
                    title="Location Availability"
                    tableColumns={locationsColumns}
                    showButtons={false}
                    navigateToLocation={false}
                    setSelectedLocations={setLocations}
                ></Locations>

                <div className="mt-4 text-right">
                    <Link to={'/admin/classes'}>
                        <Button>Cancel</Button>
                    </Link>
                    <span className="mr-4"></span>
                    <Button cc-color="purple" type="submit" disabled={disableSubmit}>
                        Save
                    </Button>
                </div>
            </form>
        </div>
    )
}

export default CreateTruckModule
